/**
 * Serialize GET params the way axios 0.21 did.
 *
 * axios 1.x walks into nested objects and writes them as bracket keys
 * (investmentType[key]=all). Many views pass whole select options as params, and an
 * option label is a React element whose $$typeof is a Symbol, so encodeURIComponent
 * throws "Cannot convert a Symbol value to a string". The request is never sent and
 * the view keeps its spinner. 0.21 sent an object as one JSON string instead, which
 * is what the server has always received. (Virala, Arvopaperit view, 8.10.2026.)
 */
const encode = (val) =>
  encodeURIComponent(val)
    .replace(/%3A/gi, ':')
    .replace(/%24/g, '$')
    .replace(/%2C/gi, ',')
    .replace(/%20/g, '+')
    .replace(/%5B/gi, '[')
    .replace(/%5D/gi, ']');

export const serializeParams = (params) => {
  if (!params) {
    return '';
  }
  if (params instanceof URLSearchParams) {
    return params.toString();
  }

  const parts = [];
  Object.keys(params).forEach((name) => {
    let key = name;
    let values = params[name];
    if (values === null || typeof values === 'undefined') {
      return;
    }
    if (Array.isArray(values)) {
      key = `${key}[]`;
    } else {
      values = [values];
    }
    values.forEach((value) => {
      let v = value;
      if (v instanceof Date) {
        v = v.toISOString();
      } else if (v !== null && typeof v === 'object') {
        v = JSON.stringify(v);
      }
      parts.push(`${encode(key)}=${encode(v)}`);
    });
  });
  return parts.join('&');
};

export default serializeParams;
